<template>
  <div id="app_acc">
    <AccHead v-if=headImgID v-bind:accHeadline=headText v-bind:headImgCredit=headImgCredit v-bind:headImgID=headImgID v-bind:headImgFormat=headImgFormat />
    <AccHead v-else v-bind:accHeadline=headText />
    <div class="acc_loading blink" v-if="loading === true && headText !== ''">Lädt Daten...</div>
    <div v-if="numViewItems === 0">
    <li class="vue-list" v-for="item in arrItems" :key="item">
      <AccItem v-bind:btnHeadline=item.headline v-bind:btnImage=item.headlineImg v-bind:btnImageFormat=item.headlineImgFormat v-bind:accMainText=item.text v-bind:btnUpline=item.kicker v-bind:accContextual=item.contextual v-bind:accGrade=item.grade v-bind:accImgID=item.img v-bind:accFormat=item.imgFormat v-bind:accImgCredit=item.imgCredit v-bind:accImgSubline=item.imgSubline />
    </li>
  </div>
  <div v-else>
    <li class="vue-list" v-for="item in arrShortlist" :key="item">
      <AccItem v-bind:btnHeadline=item.headline v-bind:btnImage=item.headlineImg v-bind:btnImageFormat=item.headlineImgFormat v-bind:accMainText=item.text v-bind:btnUpline=item.kicker v-bind:accContextual=item.contextual v-bind:accGrade=item.grade v-bind:accImgID=item.img v-bind:accFormat=item.imgFormat v-bind:accImgCredit=item.imgCredit v-bind:accImgSubline=item.imgSubline />
    </li>
    <div v-on:click="switchList" class="acc_button">MEHR ANZEIGEN</div>
  </div>
  </div>
</template>

<script>
import AccHead from './components/AccHead.vue' 
import AccItem from './components/AccItem.vue'


export default {
  name: 'App',
  components: {
     AccHead,
     AccItem
  },
  data() {
    return { 
      loading:true,
      csvURL:"",
      headText: "",
      headImgCredit: "",
      headImgID: "",
      headImgFormat: "",
      numViewItems: 0,
      arrItems: [],
      arrShortlist: []
    } 
  },
  methods: {
    switchList: function () {
      this.numViewItems = 0;
    },
    onCompleteHeader: function(_headText, _headImgCredit, _headImgID, _headImgFormat, _accViewItems) {
      this.headText = _headText
      this.headImgCredit = _headImgCredit
      this.headImgID = _headImgID
      this.headImgFormat = _headImgFormat
      if (_accViewItems) {
        
          this.numViewItems = _accViewItems
        }

    },  
    readHeaderFile: function(_url) {
        
        let self = this
        let url = _url + '&gid=0' 
        
        this.$papa.parse(url, {
            download: true,
            header: true,
            complete: function(results) {              
                  let dataPath = results.data[0]
                  self.onCompleteHeader(dataPath.accHeadline, dataPath.headImgCredit, dataPath.headPolopolyID, dataPath.headImgFormat, dataPath.accViewItems)
                  self.readContentFile(self.csvUrl)
            }
        });
    },
    onCompleteContent: function(_dataObject) {
      this.arrItems.push(_dataObject)
      this.loading=false;
    }, 
    onCompleteShortlist: function(_dataObject) {
      this.arrShortlist.push(_dataObject)
      this.loading=false;
    },  
    readContentFile: function(_url) {
        
        let self = this
        let url = _url + '&gid=604828219' 

        this.$papa.parse(url, {
            download: true,
            header: true,
            complete: function(results) {

                  for (var j = 0; j < results.data.length; j++) {
                    let dataObject = results.data[j]
                    if (dataObject.headline!=""){
                    self.onCompleteContent(dataObject)
                    }
                  }

                  if (self.numViewItems >= results.data.length) {
                    self.numViewItems = 0;
                  }

                  for (var k = 0; k < self.numViewItems; k++) {
                    let dataObject = results.data[k]
                    if (dataObject.headline!=""){
                    self.onCompleteShortlist(dataObject)
                    }

                  }

                  
            }
        });
    },
    
  },
  mounted() {  

    
      this.csvUrl = document.getElementById("spreadsheet-url").dataset.url

      this.readHeaderFile(this.csvUrl)   
      //this.readContentFile(this.csvUrl)  
      
    }
}

</script>

<style scoped>
@import './assets/styles.css';
</style>
